import { render, staticRenderFns } from "./FundingRequestData.vue?vue&type=template&id=40c396dc&"
import script from "./FundingRequestData.vue?vue&type=script&lang=ts&"
export * from "./FundingRequestData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports